import { ref, computed } from 'vue'
import {
  AUTH_TOKEN_NAME,
  LS_SELECTED_CHILD,
  API_BASE_URL,
  LOGOUT_URL,
  SITE_BASE_URL
} from '@/config'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import useApiRequest from '@/_core/hooks/useApiRequest'
import { getProfile, denyTutorial, demo, subscriptions } from '@/services/user'
import { logoutUser } from '@/services/auth'
import Subscription from '@/models/Subscription'
import Subscriptions from '@/models/Subscriptions'
import { LS_BASKET_ID_KEY } from '@/modules/Basket/config'

export default function UserController () {
  const { $on, $off, $emit } = useEventEmitter()

  // Login logic
  const login = () => {
    location.href = `${API_BASE_URL}auth/login/id/`
  }

  // Logout logic
  const logoutRequest = useApiRequest(logoutUser)
  logoutRequest.$on('success', () => {
    $emit('requestlogout-success')
    logoutOnFrontend()
    location.href = `${LOGOUT_URL}signout?return=${SITE_BASE_URL}`
    localStorage.removeItem(LS_BASKET_ID_KEY)
  })
  logoutRequest.$on('error', () => {
    $emit('requestlogout-error', profileRequest.errors)
  })

  const logoutOnFrontend = () => {
    $emit('logout-success')
    localStorage.removeItem(AUTH_TOKEN_NAME)
    profile.value = null
  }

  const logout = () => {
    logoutRequest.request()
  }

  // Profile
  const profile = ref(null)
  const profileRequest = useApiRequest(getProfile)
  profileRequest.$on('success', () => {
    profile.value = profileRequest.data
    if (!profile.value.subscriptions) requestSubscriptions()
    $emit('requestprofile-success', profileRequest.data)
  })
  profileRequest.$on('error', () => {
    $emit('requestprofile-error', profileRequest.errors)
  })
  const requestProfile = async () => {
    await profileRequest.request()
  }

  // Tutorial
  const denyTutorialRequest = useApiRequest(denyTutorial)
  denyTutorialRequest.$on('success', () => {
    $emit('denytutorial-success', denyTutorialRequest.data)
    if (profile.value) profile.value.showTutorial = false
  })
  denyTutorialRequest.$on('error', () => {
    $emit('denytutorial-error', denyTutorialRequest.errors)
  })
  const requestDenyTutorial = async () => {
    await denyTutorialRequest.request()
  }

  // Demo state
  // const subscription = ref(null) ### вынести из profile в user
  const demoRequest = useApiRequest(demo)
  demoRequest.$on('success', () => {
    profile.value.subscription = new Subscription(demoRequest.data)
    $emit('requestDemo-success', demoRequest.data)
  })
  demoRequest.$on('error', () => {
    $emit('requestDemo-error', demoRequest.errors)
  })
  const requestDemo = async () => {
    await demoRequest.request()
  }

  // Subscriptions
  const subscriptionsRequest = useApiRequest(subscriptions)
  subscriptionsRequest.$on('success', () => {
    profile.value.subscriptions = subscriptionsRequest.data.map(el => new Subscriptions(el))
    requestDemo()
    $emit('requestSubscriptions-success', subscriptionsRequest.data)
  })
  subscriptionsRequest.$on('error', () => {
    $emit('requestSubscriptions-error', subscriptionsRequest.errors)
  })
  const requestSubscriptions = async () => {
    await subscriptionsRequest.request()
  }

  // Children
  const selectedChildId = ref(null)

  const selectChild = id => {
    const prevChildId = localStorage.getItem(LS_SELECTED_CHILD)
    selectedChildId.value = id
    localStorage.setItem(LS_SELECTED_CHILD, id)
    if (prevChildId !== id) $emit('child-changed', id)
  }

  const selectedChild = computed(() => {
    return profile.value?.children?.find(o => o.id === selectedChildId.value)
  })

  $on('requestprofile-success', () => {
    let id = Number(localStorage.getItem(LS_SELECTED_CHILD))
    if (!profile.value.children?.find(o => o.id === id)) {
      id = profile.value.children[0]?.id
    }
    if (id) selectChild(id)
  })

  // Output.
  const output = {
    isAuthenticated: computed(
      () => !!profile.value && !!profile.value.subscription && !!profile.value.subscriptions
    ),
    login,
    logout,
    logoutOnFrontend,
    profile,
    requestProfile,
    isLoading: computed(
      () => profileRequest.isLoading || demoRequest.isLoading || subscriptionsRequest.isLoading
    ),
    requestDenyTutorial,
    selectChild,
    selectedChild,
    $on,
    $off,
    requestDemo
    // subscription ###
  }

  return output
}
